import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy Exception Command Center — superseded by Operations Workspace,
 * which embeds the same exception feed plus Actions, Recommendations,
 * Bottlenecks, Health, and full ack/snooze/resolve lifecycle.
 * Kept as a permanent redirect so old bookmarks/links keep working.
 */
export const Route = createFileRoute("/_authenticated/app/exceptions")({
  beforeLoad: () => {
    throw redirect({ to: "/app/operations/desk", replace: true });
  },
});